import { gql } from "@apollo/client";

export const UPDATE_NAME = gql`
    mutation UpdateProfile(
        $givenName: String!,
        $familyName: String!
    ) {
        editarPerfil(input: {
            nombres: $givenName
            apellidos: $familyName
        }) {
            perfil {
                id
                nombres
                apellidos
            }
            errores {
                mensaje
                codigo
                ruta
                pista
            }
        }
    }
`;

export const UPDATE_EMPLOYMENT_DETAILS = gql`
    mutation UpdateProfile(
        $profession: String,
        $jobTitle: String,
        $companyName: String
    ) {
        editarPerfil(input: {
            profesion: $profession
            cargo: $jobTitle
            empresa: $companyName
        }) {
            perfil {
                id
                profesion
                cargo
                empresa
            }
            errores {
                mensaje
                codigo
                ruta
                pista
            }
        }
    }
`;

export const ADD_DNI = gql`
    mutation AddDni($number: String!) {
        agregarDocumento(input: {
            numero: $number
            tipoDocumento: DNI
        }) {
            documento {
                id
                numero
            }
            errores {
                mensaje
                codigo
                ruta
                pista
            }
        }
    }
`;
